import ContinuePage from "@components/ContinuePage"

export default function ReadyCommitPage() {
  return <ContinuePage emoji="✅" translationKey="abFeedbackV1.readyCommit" />
}
